import { Injectable } from '@angular/core';

import { UserMemoModel } from '../../models/models';
import { ApiProvider } from '../api/api';

@Injectable()
export class UserMemoProvider {
  private items: UserMemoModel[] = [];

  constructor(
    private api: ApiProvider) {
  }

  List(user_id: number) {
    return new Promise((resolve, reject) => {
      this.api.get(`user/${user_id}/memo`).subscribe(res => {
        const data = res.json();
        data.map(x => {
          this.items.push({
            _id: x.id,
            UserId: x.user_id,
            Name: x.name,
            Memo: x.memo
          });
        });
        this.Sort();
        resolve(this.items);
      });
    });
  }

  Remove(item: UserMemoModel) {
    return new Promise((resolve, reject) => {
      this.api.delete(`user/${item.UserId}/memo/${item._id}`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          this.items = this.items.filter(m => m._id !== item._id);
          resolve(this.items);
        }
      });
    });
  }

  Save(item: UserMemoModel) {
    return new Promise((resolve, reject) => {
      const isNew = item._id === undefined;
      this.api.post(`user/${item.UserId}/memo/${item._id}`, { name: item.Name, memo: item.Memo }).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          item._id = data.id;
          if (isNew) {
            this.items.push(item);
          }
          else {
            this.items.map(x => {
              if (x._id === item._id) {
                x = item;
              }
            });
          }
          this.Sort();
          resolve(item);
        }
      });
    });
  }

  Sort() {
    this.items.sort((a: UserMemoModel, b: UserMemoModel) => {
      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
      else if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
      else return 0;
    });
    return this.items;
  }

}



// WEBPACK FOOTER //
// ./src/providers/user/user-memo.ts